import Repository from './Repository.js';

class DashboardRepository extends Repository {
    async getDashboard(query) {
        return await this.get('dashboard', query);
    }
}

export default new DashboardRepository();
